<template lang="pug">
  .height-100
    transition(name='fade-quick')
      .modal.is-active(
        v-if="showModalAdjuntar"
        :class="{'modal-sidebar-desktop-open': showSidebarDesktop }"
      )
        .modal-background(@click="closeModalAdjuntar()")
        upload-image(
          name="reunion_capacitacion",
          folder="reunion",
          @save="guardarAdjunto"
          @close="closeModalAdjuntar"
        )
          span(slot="title") Adjuntar archivo
          span(slot="explanation") Adjunta el archivo deseado
          i.fa.fa-file-text(slot="topIcon")
    .title.pt-5
      span.fw-400 {{ idReunion ? 'Editar' : 'Nuevo' }}
    transition-group.contenedor-box-transition(name="fade-smooth-two", tag="div")
      .box.lista-solicitud-vacaciones.contenedor-interno(key="box-lista")
        .display-flex.mb-5
          .volver.display-flex.flex-1
            button.button.is-small(@click="volver()")
              span.icon.is-small
                i.fa.fa-arrow-left
              span Volver
          button.button.is-small.mr-5(v-if="form.estado !== 2" @click="guardar()")
            span.icon.is-small
              i.fa.fa-floppy-o
            span Guardar
          button.button.is-small.is-primary.mr-5(v-if="form.estado === 0" @click="cambiarEstado(1)")
            span Terminar
          button.button.is-small.is-danger.mr-5(v-if="form.estado === 0" @click="cambiarEstado(2)")
            span No se realizó
          button.button.is-small.is-success.mr-5(v-if="form.estado === 0" @click="notificar()")
            span Notificar
          button.button.is-small.is-primary.mr-5(v-if="form.estado === 1 && form.tipo === 'capacitacion'" @click="exportarPdf()")
            span Exportar PDF
          button.button.is-small.is-success(v-if="form.estado === 1" @click="exportarExcel()" :class="{ 'is-loading': isExporting }")
            span Exportar Excel
          // button.button.is-small.is-warning(@click="isLoadingReunion = !isLoadingReunion")
            span cambiarEstado
        .body.pt-10
          .title
            .field
              .control.margin-bottom-10.flex-1
                label.radio
                  input.radio(
                    type="radio",
                    name="reunion"
                    v-model="form.tipo"
                    value="reunion"
                    :disabled="isLoadingReunion || esReunionTerminada || esReunionAnulada"
                  )
                  span.margin-left-5 Reunión
                label.radio
                  input.radio(
                    type="radio",
                    name="reunion"
                    v-model="form.tipo"
                    value="capacitacion"
                    :disabled="isLoadingReunion || esReunionTerminada || esReunionAnulada"
                  )
                  span.margin-left-5 Capacitación
            .display-flex
              .control.margin-bottom-10.flex-1
                p.margin-bottom-5 Título
                input.input(
                  type="text",
                  v-model="form.titulo"
                  :disabled="isLoadingReunion || esReunionTerminada || esReunionAnulada"
                )

            .control.margin-bottom-10.mt-10(v-if="form.tipo === 'capacitacion'")
              p.margin-bottom-5 Nombre del capacitador
              input.input(
                type="text",
                v-model="form.nombreCapacitador"
                :disabled="isLoadingReunion || esReunionTerminada || esReunionAnulada"
              )
            .control.margin-bottom-10.mt-10
              p.margin-bottom-5 Descripción
              textarea.textarea.w-300(
                style="field-sizing: content !important;",
                v-model="form.descripcion"
                :disabled="isLoadingReunion || esReunionTerminada || esReunionAnulada"
              )
            .field
              .control.margin-bottom-10.flex-1
                label.radio
                  input.radio(
                    type="radio",
                    name="modalidad"
                    v-model="form.modalidad"
                    value="presencial"
                    @change="handlerModalidad"
                    :disabled="isLoadingReunion || esReunionTerminada || esReunionAnulada"
                  )
                  span.margin-left-5 Presencial
                label.radio
                  input.radio(
                    type="radio",
                    name="modalidad"
                    v-model="form.modalidad"
                    @change="handlerModalidad"
                    value="virtual"
                    :disabled="isLoadingReunion || esReunionTerminada || esReunionAnulada"
                  )
                  span.margin-left-5 Virtual
            .display-flex
              .control.margin-bottom-10.m-2(v-if="form.modalidad === 'presencial'")
                p.margin-bottom-5 Sala
                .select
                  select(v-model="form.idSala" :disabled="isLoadingReunion || isLoadingSalas || esReunionTerminada || esReunionAnulada")
                    option(v-for="o in salas" :value="o.id") {{ o.titulo | truncateText(20) }}
              .control.margin-bottom-10.flex-1.mt-10(v-if="form.modalidad === 'virtual'")
                p.margin-bottom-5 Link
                input.input(
                  type="text",
                  v-model="form.link"
                  :disabled="isLoadingReunion || esReunionTerminada || esReunionAnulada"
                )

            .display-flex.mt-5
              .control.mr-5
                p.margin-bottom-5 Fecha
                input.input.w-100(
                  type="date",
                  v-model="form.fecha"
                  step="1"
                  :disabled="isLoadingReunion || esReunionTerminada || esReunionAnulada"
                )
              .control.mr-5
                p.margin-bottom-5 Desde
                input.input.w-80(
                  type="time",
                  v-model="form.horaDesde"
                  step="60"
                  :disabled="isLoadingReunion || esReunionTerminada || esReunionAnulada"
                )
              .control
                p.margin-bottom-5 Hasta
                input.input.w-80(
                  type="time",
                  v-model="form.horaHasta"
                  step="60"
                  :disabled="isLoadingReunion || esReunionTerminada || esReunionAnulada"
                )
            .display-flex.fdr.space-evenly.flex-wrap.pt-10(v-if="mostrarAsistentes")
              asistentes-lista(
                :codigoCreador="form.codigoCreador"
                :esReunionTerminada="esReunionTerminada"
                :esReunionAnulada="esReunionAnulada"
                @save="saveAsistente()"
                ref="asistenteRef"
              )
            template(v-if="esReunionTerminada || esReunionAnulada")
              .field.mt-5.text-align-left
                strong.margin-bottom-5 Minuta
                .control.margin-top-10.flex-1
                  label.radio
                    input.radio(
                      type="radio",
                      name="minuta"
                      @change="handlerMinuta"
                      v-model="form.minutaOpcion"
                      value="texto"
                      :disabled="isLoadingReunion || esReunionAnulada"
                    )
                    span.margin-left-5 Texto
                  label.radio
                    input.radio(
                      type="radio",
                      name="minuta"
                      @change="handlerMinuta"
                      v-model="form.minutaOpcion"
                      value="link"
                      :disabled="isLoadingReunion || esReunionAnulada"
                    )
                    span.margin-left-5 Archivo adjunto
              .control.margin-bottom-10.mt-10(v-if="form.minutaOpcion === 'texto'")
                textarea.textarea.w-300(
                  style="field-sizing: content !important;",
                  v-model="form.minutaDescripcion"
                  :disabled="isLoadingReunion || esReunionAnulada"
                )
              .control.margin-bottom-10.flex-1.mt-10(v-if="form.minutaOpcion === 'link'")

                .mb-5.mt-5.adjunto(v-if="form.minutaLink")
                  a.button.is-small(:href="form.minutaLink", target="_blank")
                    span.icon.is-small
                      i.fa.fa-paperclip.is-small
                    span Ver adjunto
                  span.icon.color-red.margin-left-5.cursor-pointer(@click="borrarAdjunto()" :style="{'pointer-events': esReunionAnulada ? 'none' : 'auto'}", tittle="Borrar adjunto")
                    i.fa.fa-trash
                button.button.is-small.is-primary(v-else @click="abrirModalAdjuntar" :disabled="esReunionAnulada")
                  span.icon.is-small
                    i.fa.fa-upload.is-small
                  span Adjuntar



</template>

<script>
import moment from 'moment'
import { apiGet, apiPost, apiPut, apiGetExcel, notify } from '../util/general'
import AsistentesLista from '../components/Lista_Asistentes_Empleados_Multiple'
import uploadImage from '../components/Component_Upload_Image'
export default {
  name: 'gestion-reuniones-editar',
  data () {
    return {
      salas:[],
      isLoadingReunion:false,
      isLoadingSalas:false,
      form : {
        titulo        :null,
        descripcion   :null,
        estado        :null,
        tipo          :'reunion',
        modalidad     :'presencial',
        link          :null,
        idSala        :null,
        fecha         : moment().format('YYYY-MM-DD'),
        horaDesde     :null,
        horaHasta     :null,
        minutaDescripcion:null,
        minutaLink:null,
        minutaOpcion:'texto',
        codigoCreador:null,
        nombreCapacitador : ''
      },
      mostrarAsistentes:true,
      showModalAdjuntar: false,
      esReunionTerminada: false,
      esReunionAnulada: false,
      API_ROUTE        : process.env.API_ROUTE,
      EMPRESA          : process.env.EMPRESA,
      token                          : localStorage.getItem('token'),
      codigo                          : localStorage.getItem('codigo'),
      isExporting       : false
    }
  },
  computed : {
    showSidebarDesktop () {
      return this.$store.getters.showSidebarDesktop
    },
    idReunion () {
      return +this.$route.params.idReunion
    }
  },
  components: {
    'asistentes-lista' : AsistentesLista,
    'upload-image': uploadImage
  },
  created () {
  },
  mounted () {
    this.fetchSalas()
    if (this.idReunion) {
      this.fetchReunion()
    }
  },
  watch: {
    // Observa los cambios en el parámetro "id" de la ruta
    '$route.params.idReunion' (id) {
      if (this.idReunion) {
        this.fetchReunion()
      } else {
        this.limpiarDatos()
        this.fetchSalas()
      }
    }
  },
  methods: {
    notificar () {
      var vm = this
      if (!vm.form.titulo) return notify(vm, 'error', 'Error', 'Escriba un título.')
      if (!vm.form.descripcion) return notify(vm, 'error', 'Error', 'Escriba una descripción.')
      if (!vm.form.fecha) return notify(vm, 'error', 'Error', 'Escriba una fecha.')
      if (!vm.form.horaDesde) return notify(vm, 'error', 'Error', 'Escriba una hora de desde.')
      if (!vm.form.horaHasta) return notify(vm, 'error', 'Error', 'Escriba una hora de hasta.')
      if (vm.form.modalidad === 'presencial' && !vm.form.idSala) return notify(vm, 'error', 'Error', 'Escoja una sala.')
      if (vm.form.modalidad === 'virtual' && !vm.form.link) return notify(vm, 'error', 'Error', 'Escriba un link para la reunión o capacitación.')
      vm.isLoadingReunion = true
      apiPost(vm, '/reunion/gestion/' + vm.idReunion + '/notificar', vm.form, function (data) {
        notify(vm, 'success', 'Éxito', 'Se ha notificado la reunión correctamente')
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoadingReunion = false
      })
    },
    guardarAdjunto (fileSubido) {
      var vm = this
      vm.closeModalAdjuntar()
      vm.form.minutaLink = fileSubido.file.ruta
    },
    abrirModalAdjuntar () {
      var vm = this
      vm.showModalAdjuntar = true
    },
    closeModalAdjuntar () {
      var vm = this
      vm.showModalAdjuntar = false
    },
    borrarAdjunto () {
      var vm = this
      if (vm.esReunionAnulada) return
      vm.form.minutaLink = ''
    },
    limpiarDatos () {
      this.isLoadingSalas = false
      this.isLoadingReunion = false
      this.showModalAdjuntar = false
      this.form = {
        titulo        :null,
        descripcion   :null,
        estado        :null,
        tipo          :'reunion',
        modalidad     :'presencial',
        link          :null,
        idSala        :null,
        fecha         : moment().format('YYYY-MM-DD'),
        horaDesde     :null,
        horaHasta     :null,
        minutaDescripcion:null,
        minutaLink:null,
        codigoCreador:null,
        minutaOpcion:'texto'
      }
      this.mostrarAsistentes = false
      this.$nextTick(() => {
        this.mostrarAsistentes = true
      })
      this.esReunionTerminada = false
      this.esReunionAnulada = false
      this.salas = []
    },
    volver () {
      var vm = this
      vm.$router.push('/mis-reuniones')
    },
    handlerMinuta () {
      var vm = this
      if (vm.form.minutaOpcion === 'texto') {
        vm.form.minutaLink = null
      } else {
        vm.form.minutaDescripcion = null
      }
    },
    handlerModalidad () {
      var vm = this
      if (vm.form.modalidad === 'presencial') {
        vm.form.link = null
      } else {
        vm.form.idSala = null
      }
    },
    fetchReunion () {
      return new Promise((resolve) => {
        var vm = this
        vm.isLoadingReunion = true
        apiGet(vm, '/reunion/gestion/' + vm.idReunion, {}, function (data) {
          Object.keys(vm.form).forEach(function (key) {
            vm.form[key] = data.reunion[key]
          })
          if (data.reunion.estado === 1) {
            vm.esReunionTerminada = true
          } else if (data.reunion.estado === 2) {
            vm.esReunionAnulada = true
          }
          resolve(null)
        }, function (error) {
          notify(vm, 'error', 'Error', error.message)
          vm.$router.push('/gestion-reuniones')
        }, function () {
          vm.isLoadingReunion = false
        })
      })
    },
    fetchSalas () {
      var vm = this
      vm.isLoadingSalas = true
      apiGet(vm, '/reunion/sala/gestion', {activo:1}, function (data) {
        vm.salas = data.lista
        if (vm.salas.length > 0) {
          vm.isLoadingSalas = false
        } else {
          notify(vm, 'warning', '¡Cuidado!', 'No se encontraron salas')
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
      })
    },
    saveAsistente () {
      this.guardar({toAsignarEmpleados:true})
    },
    cambiarEstado (estado) {
      var vm = this
      if (estado === 1) {
        vm.terminar()
      } else if (estado === 2) {
        vm.anular()
      }
    },
    anular () {
      var vm = this
      vm.isLoadingReunion = true
      apiPut(vm, '/reunion/gestion/' + vm.idReunion + '/anular', vm.form, function (data) {
        notify(vm, 'success', 'Éxito', 'Se ha anulado la reunión correctamente')
        vm.fetchReunion()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoadingReunion = false
      })
    },
    terminar () {
      var vm = this
      if (!vm.form.titulo) return notify(vm, 'error', 'Error', 'Escriba un título.')
      if (!vm.form.descripcion) return notify(vm, 'error', 'Error', 'Escriba una descripción.')
      if (!vm.form.fecha) return notify(vm, 'error', 'Error', 'Escriba una fecha.')
      if (!vm.form.horaDesde) return notify(vm, 'error', 'Error', 'Escriba una hora de desde.')
      if (!vm.form.horaHasta) return notify(vm, 'error', 'Error', 'Escriba una hora de hasta.')
      if (vm.form.modalidad === 'presencial' && !vm.form.idSala) return notify(vm, 'error', 'Error', 'Escoja una sala.')
      if (vm.form.modalidad === 'virtual' && !vm.form.link) return notify(vm, 'error', 'Error', 'Escriba un link para la reunión o capacitación.')
      vm.isLoadingReunion = true
      apiPut(vm, '/reunion/gestion/' + vm.idReunion + '/terminar', vm.form, function (data) {
        notify(vm, 'success', 'Éxito', 'Se ha terminado la reunión correctamente')
        vm.fetchReunion()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoadingReunion = false
      })
    },
    guardar ({toAsignarEmpleados} = {}) {
      var vm = this
      if (vm.isLoadingReunion) return;
      if (!vm.form.titulo) return notify(vm, 'error', 'Error', 'Escriba un título.')
      // if (!vm.form.fecha) return notify(vm, 'error', 'Error', 'Escriba una fecha.')
      // if (!vm.form.horaDesde) return notify(vm, 'error', 'Error', 'Escriba una hora de desde.')
      // if (!vm.form.horaHasta) return notify(vm, 'error', 'Error', 'Escriba una hora de hasta.')
      vm.isLoadingReunion = true
      if (vm.form.estado === 1) {
        vm.$refs.asistenteRef.guardarAsistentes()
      }
      Promise.resolve()
      .then(() => {
        if (vm.idReunion) {
          return vm.actualizar(vm, vm.form)
        } else {
          return vm.insertar(vm, vm.form)
        }
      })
      .then((data) => {
        notify(vm, 'success', 'Éxito', data.message)
        if (!vm.idReunion) vm.$router.push('/gestion-reuniones/' + data.idReunion)
        vm.fetchReunion()
        .then(() => {
          vm.$refs.asistenteRef.fetch()
        })
      })
      .catch((error) => {
        notify(vm, 'error', 'Error', error.message)
      })
      .finally(() => {
        vm.isLoadingReunion = false
        if (toAsignarEmpleados) {
          vm.$nextTick(() => {
            vm.$refs.asistenteRef.abrirModalAsignarEmpleados()
          })
        }
      })
    },
    insertar (vm, obj) {
      return new Promise((resolve, reject) => {
        apiPost(vm, '/reunion/gestion/0', obj, function (data) {
          resolve(data)
        }, function (error) {
          reject(error)
        }, function () {
          vm.isSaving = false
        })
      })
    },
    actualizar (vm, obj) {
      return new Promise((resolve, reject) => {
        apiPut(vm, '/reunion/gestion/' + vm.idReunion, obj, function (data) {
          resolve(data)
        }, function (error) {
          reject(error)
        }, function () {
          vm.isSaving = false
        })
      })
    },
    exportarPdf () {
      var vm = this
      window.open(`${vm.API_ROUTE}/reunion/imprimir/pdf?empresa=${vm.EMPRESA}&numero=${vm.idReunion}&token=${vm.token}&codigo=${vm.codigo}`, '_blank')
    },
    exportarExcel () {
      var vm = this
      vm.isExporting = true
      var obj = {
        reunion : vm.idReunion
      }
      apiGetExcel(vm, '/reunion/exportarExcel', obj, function (data) {
        var a = document.createElement('a');
        a.style = 'display: none';
        document.body.appendChild(a);

        var blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'})
        var url = window.URL.createObjectURL(blob)

        a.href = url;
        a.download = 'Asistencias_' + ((new Date()).getTime()) + '.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);

        // window.open(url);
      }, function (error) {
        console.error('Error:' + error.message)
      }, function () {
        vm.isExporting = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .textarea
    height: auto;
  .is-mobile
    .is-close
      background-color #ffd6d6 !important
  .caja
    display: block;
    padding: 0.5rem;
  .contenedor-interno
    .close
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span.clase
        font-weight bold
        text-transform uppercase

  th
    text-align center

  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6d6 !important


  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }

  .pop-over
    background: #fff;
    border-radius: 3px;
    border: 1px solid #d6dadc;
    border-bottom-color: #c4c9cc;
    -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
    box-shadow: 0 1px 6px rgba(0,0,0,.15);
    position: absolute;
    min-width: 300px
    width: 100%;
    z-index: 70;
    top 0

  .position-relative
    position relative

  .codigo-empleado
    position relative
    .control
      .input-container
        display flex
        align-items center
        .input
          flex 1
          width 100px
        .erase-data
          cursor pointer
          margin-left 5px

  .filtros-container
    padding-bottom 10px
    border-bottom 1px solid #ccc
    .title-filtro
      display flex
      text-align left
      padding-left 10px
      padding-bottom 10px
      margin-bottom 10px
      border-bottom 1px solid #ccc
      .text
        text-transform uppercase
        flex 1
      .caret
        cursor pointer

    .filtros
      margin-bottom 10px
      text-align left
      display flex
      align-items: flex-start;


      .filtro
        display inline-block
        border 1px solid #cccccc
        background-color #f9f9f9
        padding 5px
        margin 5px
        border-radius 3px
        flex 1
        max-width 25%
        .title-singular
          text-align left
          font-weight bold
          user-select: none
        .abierto-cerrado-container
          display flex
          .option
            padding 4px
            border 1px solid #565cde
            color #565cde
            cursor pointer
            transition all 0.3s ease
            height 31.5px

            &.selected
              background-color: #565cde;
              color: #fff;

        .list-container
          padding 0px 10px 0px 10px
          .option
            user-select: none
            cursor pointer
            &.selected
              color #565cde
              font-weight bold

  .boton-container
    button
      margin-left 5px



  .is-loading
    margin-top 10px

  .information
    padding-top 10px

  th
    vertical-align: middle;
  td
    vertical-align: middle;

  td
    .email
      font-size 12px
      color #9a9a9a

  .table
    font-size 13px

  .td-status
    width: 50px;
  .is-mobile
    display none
    .box
      position: relative;
    .descripcion-tipo
      margin-bottom 5px
    .motivo
      word-wrap: break-word;
      background-color: #eff5fb;
      color: #296fa8;
      padding: 10px
    .botones
      display flex
      justify-content center
      margin-top 10px
      .button
        margin-right 5px
        &:last-child
          margin-right 0px
  .modal-sidebar-desktop-open
    width: calc(100% - 180px);
  .contenedor-acciones
    display flex
    justify-content center
  .img
    padding-bottom: 10px
    img
      max-width 100%
      width 500px
      height auto
      border-radius 5px
  @media (max-width: 820px)
    .modal-sidebar-desktop-open
      width: 100%;
  @media (max-width 710px)
    .is-mobile
      display block

    .is-desktop
      display none
    .contenedor-acciones
      margin-top 5px
  @media (max-width 650px)
    .contenedor-acciones
      flex-direction: row
      margin-top 5px
      .button
        margin-bottom 5px
        &:last-child
          margin-bottom 0px

  @media (max-width: 500px)
    .caja
      width: 100%;

</style>




// WEBPACK FOOTER //
// View_Reuniones_Editar.vue?10f0c666